import React from 'react'
import SectionGrid from '../layout/SectionGrid'
import ContentGrid from '../layout/ContentGrid'
import CircularProgress from '@mui/material/CircularProgress'

/**
 * @returns {JSX.Element}
 * @constructor
 */
const LoadingPanel = () => {
	return (
		<SectionGrid>
			<ContentGrid className={"loading-panel-content"}>
				<CircularProgress className={"circular-progress"}/>
			</ContentGrid>
		</SectionGrid>
	);
}


export default LoadingPanel;
